import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

interface FireworksProps {
  show: boolean;
  onComplete: () => void;
}

const Fireworks: React.FC<FireworksProps> = ({ show, onComplete }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!show) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const updateCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);

    const particles: Array<{
      x: number;
      y: number;
      vx: number;
      vy: number;
      life: number;
      maxLife: number;
      color: string;
    }> = [];

    const colors = ['#ff6b35', '#1976d2', '#4caf50', '#ffeb3b', '#e91e63'];

    const createFirework = (x: number, y: number) => {
      for (let i = 0; i < 50; i++) {
        particles.push({
          x,
          y,
          vx: (Math.random() - 0.5) * 10,
          vy: (Math.random() - 0.5) * 10,
          life: 80,
          maxLife: 80,
          color: colors[Math.floor(Math.random() * colors.length)],
        });
      }
    };

    // Create fireworks in viewport
    createFirework(canvas.width * 0.3, canvas.height * 0.3);
    createFirework(canvas.width * 0.7, canvas.height * 0.3);
    createFirework(canvas.width * 0.5, canvas.height * 0.2);

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.1;
        p.life--;

        // Simple solid color particles
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x, p.y, 4, 4);

        if (p.life <= 0) {
          particles.splice(i, 1);
        }
      }

      if (particles.length > 0) {
        requestAnimationFrame(animate);
      } else {
        window.removeEventListener('resize', updateCanvasSize);
        setTimeout(onComplete, 500);
      }
    };

    animate();
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: window.pageYOffset,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
        }}
      />
    </Box>
  );
};

export default Fireworks;